// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1V5Pt","col":"styles_col__25sAf"};